import { textSort } from "../../operation/getTempPropEnumOption";
const DEFAULT_SORT_ORDER = 'asc';
const DEFAULT_SORT_VALUE = 'template';
const KEY_TOP = Symbol('KEY_TOP');
const KEY_BOTTOM = Symbol('KEY_BOTTOM');
export function sortPiNode(nodeList, sortInfoList) {
  if (nodeList.length < 2) return nodeList;
  const sortInfoMap = {};
  const themeOrder = {};
  let treeLevel = undefined;
  for (let i = 0; i < sortInfoList.length; i++) {
    sortInfoMap[sortInfoList[i].theme] = sortInfoList[i];
    themeOrder[sortInfoList[i].theme] = String(i);
    if (sortInfoList[i].sortDepends[0]?.value === 'treeLevel' && treeLevel === undefined) {
      treeLevel = nodeList[0].nodeManager.getNodeTreeSerialNumber(nodeList);
    }
  }
  const keyMap = {};
  const keyList = [];
  for (const node of nodeList) {
    const temp_id = node.metadata.e._sys_temp?.[0] ?? 'ff';
    if (!(temp_id in sortInfoMap)) {
      throw new Error(`temp_id ${temp_id} not found in sortInfoMap`);
    }
    let key;
    switch (sortInfoMap[temp_id].sortDepends[0]?.value?.split('-')[0]) {
      case 'top':
        key = KEY_TOP;
        break;
      case 'bottom':
        key = KEY_BOTTOM;
        break;
      case 'title':
        key = node.metadata.t;
        break;
      case 'creator':
        key = String(node.metadata.i);
        break;
      case 'createTime':
        key = String(node.metadata.h);
        break;
      case 'updateTime':
        key = String(node.metadata.m);
        break;
      case 'treeLevel':
        key = treeLevel?.[node.id] ?? '';
        break;
      case 'prop':
        const propIndex = parseInt(sortInfoMap[temp_id].sortDepends[0].value?.slice(5) ?? '0');
        let prop = node.metadata.e._sys_cascade?.[propIndex] ? node.metadata.e._sys_cascade[propIndex].join('/') : node.metadata.e._sys_temp?.[1]?.[propIndex];
        if (Array.isArray(prop)) {
          if (prop.length) {
            prop = prop[0];
          } else {
            prop = '';
          }
        }
        if (typeof prop === 'number') {
          prop = String(prop);
        } else if (prop === null || prop === undefined) {
          prop = '';
        }
        key = prop;
        break;
      case 'statusProp':
        const statusPropIndex = parseInt(sortInfoMap[temp_id].sortDepends[0].value?.slice(11) ?? '0');
        let statusProp = node.metadata.e._sys_task_status?.prop?.[statusPropIndex];
        if (Array.isArray(statusProp)) {
          if (statusProp.length) {
            statusProp = statusProp[0];
          } else {
            statusProp = '';
          }
        }
        if (typeof statusProp === 'number') {
          statusProp = String(statusProp);
        } else if (statusProp === null || statusPropIndex === undefined) {
          statusProp = '';
        }
        key = statusProp;
        break;
      case DEFAULT_SORT_VALUE:
      default:
        key = themeOrder[temp_id];
    }
    if (key in keyMap) {
      keyMap[key].push(node);
    } else {
      keyMap[key] = [node];
      if (typeof key === 'string') {
        keyList.push(key);
      }
    }
  }
  if (keyList.length > 1) {
    const order = sortInfoList.filter(sortInfo => sortInfo.sortDepends.length)[0].sortDepends[0]?.order ?? DEFAULT_SORT_ORDER;
    textSort(keyList, a => a, true);
    if (order !== DEFAULT_SORT_ORDER) {
      keyList.reverse();
    }
  }
  const nextSortInfoList = sortInfoList.map(sortInfo => ({
    theme: sortInfo.theme,
    sortDepends: sortInfo.sortDepends.map(sortDepend => ({
      order: sortDepend?.order ?? DEFAULT_SORT_ORDER,
      value: sortDepend?.value ?? DEFAULT_SORT_VALUE
    })).slice(1)
  }));
  if (nextSortInfoList.some(sortInfo => sortInfo.sortDepends.length)) {
    for (const key in keyMap) {
      keyMap[key] = sortPiNode(keyMap[key], nextSortInfoList);
    }
  }
  const resultNodeList = KEY_TOP in keyMap ? keyMap[KEY_TOP] : [];
  for (const key of keyList) {
    resultNodeList.push.apply(resultNodeList, keyMap[key]);
  }
  if (KEY_BOTTOM in keyMap) {
    resultNodeList.push.apply(resultNodeList, keyMap[KEY_BOTTOM]);
  }
  return resultNodeList;
}